<header>
  <div>
    <img src="../../assets/threekit-logo.svg" alt="">
    <span [routerLink]="['/import']" routerLinkActive="active" [class.exact]="true">Import</span>
    <span [routerLink]="['/results']" routerLinkActive="active" [class.exact]="!routeHasParams">Results</span>
  </div>
  <!--<amplify-sign-out></amplify-sign-out>-->
</header>